import userProfile from "./../../../assets/teamFow/user.png";

const profile = [
    {
        user: userProfile,
        id: "72836375",
        country: "Perú",
        jobTitle: "Senior business consultant",
        officeLocation: "PE Lima",
        fow: "Hybrid",
        date: "2023-10-25",
        percentage: "90 %",
    },
    {
        user: userProfile,
        id: "72982736",
        country: "Chile",
        jobTitle: "Administrador de base de datos",
        officeLocation: "CL Santiago (4091)",
        fow: "Hybrid",
        date: "2023-10-25",
        percentage: "100 %",
    },
    {
        user: userProfile,
        id: "72623202",
        country: "Colombia",
        jobTitle: "Service leader",
        officeLocation: "CO Bogota oficina principal",
        fow: "Hybrid",
        date: "2023-10-25",
        percentage: "80 %",
    },
    {
        user: userProfile,
        id: "72818597",
        country: "Argentina",
        jobTitle: "Business consultant",
        officeLocation: "AR Buenos Aires",
        fow: "Hybrid",
        date: "2023-10-25",
        percentage: "100 %",
    },
    {
        user: userProfile,
        id: "72765178",
        country: "Colombia",
        jobTitle: "Architecture technical leader 1",
        officeLocation: "CO Bogota oficina principal",
        fow: "Hybrid",
        date: "2023-10-25",
        percentage: "100 %",
    },
    {
        user: userProfile,
        id: "72836376",
        country: "Perú",
        jobTitle: "Senior business consultant",
        officeLocation: "PE Lima",
        fow: "Hybrid",
        date: "2023-09-25",
        percentage: "90 %",
    },
    {
        user: userProfile,
        id: "72982737",
        country: "Chile",
        jobTitle: "Administrador de base de datos",
        officeLocation: "CL Santiago (4091)",
        fow: "Hybrid",
        date: "2023-09-25",
        percentage: "100 %",
    },
    {
        user: userProfile,
        id: "72623207",
        country: "Colombia",
        jobTitle: "Service leader",
        officeLocation: "CO Bogota oficina principal",
        fow: "Hybrid",
        date: "2023-08-25",
        percentage: "80 %",
    },
    {
        user: userProfile,
        id: "72818592",
        country: "Argentina",
        jobTitle: "Business consultant",
        officeLocation: "AR Buenos Aires",
        fow: "Hybrid",
        date: "2023-08-25",
        percentage: "100 %",
    },
    {
        user: userProfile,
        id: "73029241",
        country: "Perú",
        jobTitle: "Senior business consultant",
        officeLocation: "PE Lima",
        fow: "Hybrid",
        date: "2023-07-25",
        percentage: "90 %",
    },
    {
        user: userProfile,
        id: "73029242",
        country: "Chile",
        jobTitle: "Administrador de base de datos",
        officeLocation: "CL Santiago (4091)",
        fow: "Hybrid",
        date: "2023-07-18",
        percentage: "100 %",
    },
    {
        user: userProfile,
        id: "73029243",
        country: "Colombia",
        jobTitle: "Service leader",
        officeLocation: "CO Bogota oficina principal",
        fow: "Hybrid",
        date: "2023-07-12",
        percentage: "80 %",
    },
    {
        user: userProfile,
        id: "73029244",
        country: "Argentina",
        jobTitle: "Business consultant",
        officeLocation: "AR Buenos Aires",
        fow: "Hybrid",
        date: "2023-07-06",
        percentage: "100 %",
    },
    {
        user: userProfile,
        id: "73029245",
        country: "Colombia",
        jobTitle: "Architecture technical leader 1",
        officeLocation: "CO Bogota oficina principal",
        fow: "Hybrid",
        date: "2023-07-01",
        percentage: "100 %",
    },
    {
        user: userProfile,
        id: "73029246",
        country: "Perú",
        jobTitle: "Senior business consultant",
        officeLocation: "PE Lima",
        fow: "Home office",
        date: "2023-06-25",
        percentage: "90 %",
    },
    {
        user: userProfile,
        id: "73029247",
        country: "Chile",
        jobTitle: "Administrador de base de datos",
        officeLocation: "CL Santiago (4091)",
        fow: "Roam",
        date: "2023-05-20",
        percentage: "100 %",
    },
    {
        user: userProfile,
        id: "73029248",
        country: "Colombia",
        jobTitle: "Service leader",
        officeLocation: "CO Bogota oficina principal",
        fow: "Home office",
        date: "2023-05-15",
        percentage: "80 %",
    },
    {
        user: userProfile,
        id: "73029249",
        country: "Argentina",
        jobTitle: "Business consultant",
        officeLocation: "AR Buenos Aires",
        fow: "Roam",
        date: "2023-04-10",
        percentage: "100 %",
    },
    {
        user: userProfile,
        id: "73029250",
        country: "Colombia",
        jobTitle: "Architecture technical leader 1",
        officeLocation: "CO Bogota oficina principal",
        fow: "Home office",
        date: "2023-04-05",
        percentage: "100 %",
    }
];

export default profile;
